<template>
  <v-autocomplete
    attach
    auto-select-first
    :items="items"
    v-model="selection"
    @change="$emit('change', $event)"
    outlined
    :item-text="itemText"
    :item-value="itemValue"
    :disabled="disabled"
    persistent-placeholder
    :label="label"
    :dark="dark"
    style="z-index: unset"
  >
  </v-autocomplete>
</template>

<script>
export default {
  name: "AutoCompleteFilter",
  props: {
    value: undefined,
    items: Array,
    disabled: Boolean,
    label: String,
    itemText: String,
    itemValue: String,
    dark: Boolean,
  },
  computed: {
    selection: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
};
</script>
